import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const workerListService = {
  getList,
  create,
  update,
  destroy,
  restore,
};

// GET the worker list for a property (seeds/auto-syncs server-side). Pass
// includeRemoved=true on the management screen to also get removed workers.
function getList(propertyId, includeRemoved = false) {
  return axios
    .get(apiEndpoint.workerList, {
      headers: authHeader(),
      params: { property_id: propertyId, all: includeRemoved ? 1 : undefined },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { workers: [] };
    });
}

// Add a free-form contractor, or add/re-add an existing property user.
function create(data) {
  return axios
    .post(apiEndpoint.workerList, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function update(id, data) {
  return axios
    .put(apiEndpointFunction.workerList(id), data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Remove a worker from the list (soft delete on the server).
function destroy(id) {
  return axios
    .delete(apiEndpointFunction.workerList(id), { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Re-add a previously removed worker.
function restore(id) {
  return axios
    .post(`${apiEndpointFunction.workerList(id)}/restore`, {}, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
